import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectCurrentPath } from 'src/app/shared/store/shared.selectors';
import { ProjectPageViewState, ProjectState } from './project.reducer';
import { ProjectRoutesView } from 'src/app/roles/_shared-by-role/project-dashboard/project.constants';

export const selectProjectFeature =
  createFeatureSelector<ProjectState>('project');

export const selectProjectPageViewFeature =
  createFeatureSelector<ProjectPageViewState>('projectPageView');

export const selectAllProjects = createSelector(
  selectProjectFeature,
  selectCurrentPath,
  (state, currentPath: string) => {
    if (currentPath.includes(ProjectRoutesView.MY_PROJECTS)) {
      return state.projectsByUser;
    } else if (currentPath.includes(ProjectRoutesView.ARCHIVED_PROJECTS)) {
      return state.archivedProjects;
    }

    return state.allProjects;
  }
);

export const selectProjectsListQuickFilter = createSelector(
  selectProjectFeature,
  (state) => state.quickFilter
);

export const selectProjectsGroupFiltered = createSelector(
  selectProjectFeature,
  (state) => state.projectsFiltered
);

export const selectProjectsFiltered = createSelector(
  selectProjectsGroupFiltered,
  selectProjectsListQuickFilter,
  (projects, quickFilter) => {
    const quickFilterForComparison = quickFilter?.toLowerCase() ?? '';

    return projects?.filter(
      (item) =>
        item.name?.toLowerCase().includes(quickFilterForComparison) ||
        item.description?.toLowerCase().includes(quickFilterForComparison)
    );
  }
);

export const selectCurrentProject = createSelector(
  selectProjectFeature,
  (state) => state.currentProject
);

export const selectEditProjectForm = createSelector(
  selectProjectFeature,
  (state) => state.editProjectForm
);

export const selectIsCurrentProjectUpdated = createSelector(
  selectProjectFeature,
  (state) => state.isProjectChanged
);

export const selectCurrentPhaseEditForm = createSelector(
  selectProjectFeature,
  (state) => state.currentPhaseForm
);

export const selectCurrentPhase = createSelector(
  selectProjectFeature,
  (state) => state.currentProject?.currentPhase
);

export const selectDisciplinesForCurrentPhase = createSelector(
  selectProjectFeature,
  (state) => state.disciplines
);

export const selectProjectPhases = createSelector(
  selectProjectFeature,
  (state) => state.currentProject?.phases
);

export const selectProjectPageView = createSelector(
  selectProjectPageViewFeature,
  (state) => state.projectPageView
);

export const selectIPIMSDomains = createSelector(
  selectProjectFeature,
  (state) => state.domains
);

export const selectIPIMSDomain = createSelector(
  selectProjectFeature,
  (state) => state.currentProject?.currentPhase?.ipimsDomain
);

export const selectProjectValueRecognitionForm = createSelector(
  selectProjectFeature,
  (state) => state.projectValueRecognitionDetailsForm
);

export const selectProjectValueRecognition = createSelector(
  selectProjectFeature,
  (state) => state.projectValueRecognitionDetails
);

export const selectHasUserGlobalAdminAccess = createSelector(
  selectProjectFeature,
  (state) => state.hasUserGlobalAdminAccess
);

export const selectAttentionItemsProjectSettings = createSelector(
  selectProjectFeature,
  (state) => state.AttentionItemsProjectSettings
);
